var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.role(
      'admin',
      'departmentManager',
      'manager',
      'safetyRepresentative'
    )
  )?_c('v-btn',{staticClass:"primary accent-4 white--text mr-2",attrs:{"small":""},on:{"click":_vm.toggle}},[(_vm.state)?[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("account_tree")])]:[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("table_chart")])],_vm._v("\n  "+_vm._s(_vm.state
      ? _vm.$t("profile.history.showTreeView")
      : _vm.$t("profile.history.showTable"))+"\n")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }